module.exports = __webpack_public_path__ + "img/收货地址.11f60965.svg";